import { render, staticRenderFns } from "./consequence.vue?vue&type=template&id=2f52555a&scoped=true"
import script from "./consequence.vue?vue&type=script&lang=js"
export * from "./consequence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f52555a",
  null
  
)

export default component.exports